module.exports = __webpack_public_path__ + "img/slide_waiting-room.268c036.jpg";